import { useQueryClient } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { useOverlayContext } from 'seagull';
import { QueryKeys } from "../../../hooks/reactQuery/queryKeys";
import { useMutationState } from "../../../hooks/reactQuery/useMutationState";
import { useFeatureFlags } from "../../../hooks/useFeatureFlags";
import { makeFailure, makeSuccess, sendErrReport } from "../../../infra/utils";
import { useStoreActions } from "../../../store/store-context";
import { NameThisDocumentModal, NameThisDocumentModalError } from "../NameThisDocumentModal/NameThisDocumentModal";
import { jsx as _jsx } from "react/jsx-runtime";
export const useRenameLegalTerms = _ref => {
  let {
    errorToastTestId
  } = _ref;
  const {
    api
  } = useStoreActions();
  const queryClient = useQueryClient();
  const {
    showModal,
    showErrorToast
  } = useOverlayContext();
  const {
    RICH_TEXT_LEGAL_TERMS = false
  } = useFeatureFlags();
  const {
    mutateAsync: renameLegalTerms,
    isPending
  } = useMutationState({
    mutationFn: async _ref2 => {
      let {
        legalTermsId,
        newName
      } = _ref2;
      try {
        RICH_TEXT_LEGAL_TERMS ? await api.business.renameLegalTerms(legalTermsId, newName) : await api.business.renameLegalTermsOld(legalTermsId, newName);
        return makeSuccess(undefined);
      } catch (error) {
        var _error$response;
        if (error instanceof AxiosError && ((_error$response = error.response) === null || _error$response === void 0 ? void 0 : _error$response.status) === 400 && NameThisDocumentModalError[error.response.data.error]) {
          return makeFailure(error.response.data.error);
        }
        return makeFailure(error);
      }
    },
    onSettled: result => {
      if (result !== null && result !== void 0 && result.success) {
        queryClient.invalidateQueries({
          queryKey: [QueryKeys.LegalTerms]
        });
      } else {
        if (!NameThisDocumentModalError[result === null || result === void 0 ? void 0 : result.error]) {
          const message = 'An unknown error has occurred.';
          sendErrReport(result === null || result === void 0 ? void 0 : result.error);
          showErrorToast(message, errorToastTestId);
        }
      }
    }
  });
  const onRenameLegalTerm = async legalTerms => {
    await showModal({
      closeOnEscapeKey: true,
      closeOnClickOutside: true,
      content: _ref3 => {
        let {
          dismissModal
        } = _ref3;
        return /*#__PURE__*/_jsx(NameThisDocumentModal, {
          currentFileName: legalTerms.name,
          currentLegalTermsId: legalTerms.id,
          onConfirm: newName => renameLegalTerms({
            legalTermsId: legalTerms.id,
            newName
          }),
          dismissModal: dismissModal
        });
      }
    });
  };
  return {
    renameLegalTerms: onRenameLegalTerm,
    isPending
  };
};